import { render, staticRenderFns } from "./ShowSensors.vue?vue&type=template&id=2f37c240&"
import script from "./ShowSensors.vue?vue&type=script&lang=js&"
export * from "./ShowSensors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports